var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-circle w-100 fill-height d-flex justify-center align-center flex-column pa-4"},[_c('div',{staticClass:"spinner"}),_c('div',{staticClass:"mt-4 w-75 text-center"},[_c('span',[_vm._v(_vm._s(_vm.title))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }